/* eslint-disable react/no-array-index-key */
/** @jsx jsx */
import { jsx, Box, Container, Flex } from 'theme-ui';
import React, { FunctionComponent } from 'react';
import classNames from 'classnames';

// Components
import BackgroundImage from 'gatsby-background-image';
import Text, { TEXT_TYPES } from '../text';
import WpLink from '../link';

// Hooks
import useLinesBg from '../../hooks/useLinesBg';

// Icons
import ChevronRight from '../../../static/assets/icons/outlined/directions/chevron/right.svg';

// Styles
import { baseStyle } from './style';

export interface BreadcrumbItem {
  label: string;
  uri?: string;
}
export interface BreadcrumbProps {
  className?: string;
  items: BreadcrumbItem[];
}

const Breadcrumb: FunctionComponent<BreadcrumbProps> = React.memo(
  ({ className, items }) => {
    // Hooks
    const { fluid: fluidBg } = useLinesBg();

    return (
      <Box
        className={classNames('Breadcrumb', className)}
        sx={baseStyle.mainContainer}
      >
        <BackgroundImage fluid={fluidBg} sx={baseStyle.mainBackgroundImage}>
          <Container sx={baseStyle.container}>
            <Flex sx={baseStyle.itemContainer}>
              {items.map((item: BreadcrumbItem, idx: number) => (
                <Flex key={idx} sx={baseStyle.itemGroup}>
                  <WpLink url={item.uri}>
                    <Text type={TEXT_TYPES.SUBTITLE} sx={baseStyle.text}>
                      {item.label}
                    </Text>
                  </WpLink>
                  {idx < items.length - 1 && (
                    <ChevronRight sx={baseStyle.icon} />
                  )}
                </Flex>
              ))}
            </Flex>
          </Container>
        </BackgroundImage>
      </Box>
    );
  },
);

export default Breadcrumb;
